import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isEdit: false,
};

const adminAgentIndividualInfoSlice = createSlice({
  name: "ADMIN_AGENT_INDIVIDUAL_INFO_SLICE",
  initialState,
  reducers: {
    SET_IS_EDIT_AGENT_INDIVIDUAL_INFO_FORM: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isEdit = action.payload;
    },
  },
});

export const { SET_IS_EDIT_AGENT_INDIVIDUAL_INFO_FORM } =
  adminAgentIndividualInfoSlice.actions;

export default adminAgentIndividualInfoSlice.reducer;
